export const ASSESS = 0;
export const VALIDATION = 1;
export const REASSESS = 2;